import { render, staticRenderFns } from "./BooksPurchaseByCenter.vue?vue&type=template&id=66865c89&"
import script from "./BooksPurchaseByCenter.vue?vue&type=script&lang=js&"
export * from "./BooksPurchaseByCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports